import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { BaseFormComponent } from '../../base-form.component';
import { CommonFunctions } from 'src/app/shared/common/common-functions';
import { Store, select } from '@ngrx/store';
import * as fromBusinessDetailsSearch from 'src/app/store/feature-stores/business-details-store';
import { Subscription } from 'rxjs';
import { AppState } from 'src/app/store/reducers/app.state';
import { UntypedFormControl, Validators } from '@angular/forms';
import { FormFunctions } from 'src/app/shared/form-components/form-functions';
import { JurisdictionDropDownLst } from 'src/app/shared/common/common-constants';

@Component({
  selector: 'app-business-number-field-core[formGroup][propertyName]',
  templateUrl: './business-number-field-core.component.html',
  styleUrls: ['./business-number-field-core.component.scss'],
  standalone: false,
})
export class BusinessNumberFieldCoreComponent extends BaseFormComponent implements OnInit {

  @Input() maxLength?: number;

  @Output() userInput?= new EventEmitter<number>();
  @Output() search: EventEmitter<string> = new EventEmitter<string>();
  @Output() confirmBnNumberChange = new EventEmitter<any>(); 

  businessDetails: any = {};
  orgBookDetails: any;
  subscriptions: Subscription[] = [];
  jurisdictionData = JurisdictionDropDownLst;
  isShowConfirmLegalNameDate: boolean;

  constructor(
    private commonFunctions: CommonFunctions,
    private store$: Store<AppState>,
    public formFunctions: FormFunctions,
  ) {
    super(commonFunctions);
  }

  private confirmLegalNameDateFields = {
    confirmLegalNameDate: new UntypedFormControl('', [Validators.required])
  };

  ngOnInit() {    
    try {
      this.isShowConfirmLegalNameDate = true;
      super.ngOnInit();
      if (this.maxLength == null) {
        this.maxLength = 9; // Default field length
      }    
      
      this.formFunctions.addRemoveFormFields(
        [this.confirmLegalNameDateFields],
        [],
        this.formGroup);     
    } catch(ex) {
      console.log('[BusinessNumberFieldCoreComponent] ex=' + ex );  
    } 
  }

  ngAfterViewInit(): void {
    this.subscriptions.push(
      this.store$.pipe(select(fromBusinessDetailsSearch.Selectors.getOrgBookDetails)).subscribe(
        orgBookDetails => { 
          //support unit test. Make sure it is orgBookDetails data
          if (orgBookDetails && orgBookDetails.found != undefined) {             
              this.orgBookDetails = orgBookDetails; 
          }  
          console.log('[BusinessNumberFieldCoreComponent] orgBookDetails=' + JSON.stringify(orgBookDetails));
          
          let addConfirmLegalNameDateFields = null;
          // this code will be triggered more than once
          if (this.orgBookDetails && this.orgBookDetails.found != undefined && this.orgBookDetails.found == true) {   
            if (this.orgBookDetails.entityType === 'SP') {
              this.orgBookValidation('ENTITYTYPE_SP');
              return;
            } else if (this.findValidJurisdiction(this.orgBookDetails?.jurisdiction) === '')  {        
              this.orgBookValidation('JURISDICTION_NOTFOUND');
              return;
            }                  
          }                        

          if (this.orgBookDetails && this.orgBookDetails?.isOrgBookServiceDown === true) {
            this.orgBookValidation('DOWN');
            return;
          }

          if (this.orgBookDetails && this.orgBookDetails?.found === false) {
            this.orgBookValidation('NOTFOUND');
            return;
          } 
          
        }
      )
    );      
  }

  ngOnDestroy(): void {    
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
  }

  userAction(input: number) {
    if (this.userInput != null) {
      this.userInput.emit(input);
    }
  }

  clearSearch() {     
    this.formGroup.get('previousAcctCRA').setValue('');
    this.clearSearchStore();
  }

  clearSearchStore() {    
    this.store$.dispatch(
      fromBusinessDetailsSearch.Actions.ClearBusinessNumber()
    );
  }

  onSearch() {
    this.resetSearch();
    const businessNumber = this.formGroup.get('previousAcctCRA').value;   
    if (!this.isInvalid() && businessNumber !== '') {
      this.store$.dispatch(
        fromBusinessDetailsSearch.Actions.SearchBusinessNumber(
          {
            payload: {
              businessNumber: businessNumber,
            }
          })
      );
    }
  }

  handleRadioButtonClick(event: any) {    
    // This is subscribered by coporation--> business-details -->orgBookConfirmBnNumberChangeHandler 
    const updateSearchResult = {
      update: event,
      orgBookDetails: event === 'Y'? this.orgBookDetails : null
    }

    if (event === 'Y') {
      this.confirmBnNumberChange.emit(updateSearchResult);
    } else {
      this.isShowConfirmLegalNameDate = false;
      this.formGroup.controls.confirmLegalNameDate?.setValue(null);      
      this.confirmBnNumberChange.emit(updateSearchResult);
      this.clearSearchStore();
    }
  }
  
  findValidJurisdiction(jurisdiction: any){
    let findName = '';   
    this.jurisdictionData.forEach(e=> {
      if (e.code && e.code.trim() == jurisdiction || e.code2 && e.code2.trim() == jurisdiction) {       
        findName = e.display;  
      } 
    }); 
    return findName;
  }

  showConfirmLegalNameDate() {
    if (this.isShowConfirmLegalNameDate === true && 
        this.orgBookDetails?.found === true && 
        this.findValidJurisdiction(this.orgBookDetails?.jurisdiction) !=='' && 
        this.orgBookDetails?.entityType !== 'SP') {
        return true;
    } else {
        return false;
    }    
  }

  private resetSearch() {
    this.isShowConfirmLegalNameDate = true; 
    this.orgBookDetails = null;
    const updateSearchResult = {
      update: 'RESET',
      orgBookDetails: null
    };
    this.formGroup.controls.confirmLegalNameDate?.setValue(null);
    this.confirmBnNumberChange.emit(updateSearchResult);   
  }

  private orgBookValidation(update: string) {     
      const updateSearchResult = {
        update: update,
        orgBookDetails: null
      };
      this.confirmBnNumberChange.emit(updateSearchResult);    
  } 
}
